document.addEventListener('DOMContentLoaded', () => {
    const teamMemberBtns = document.querySelectorAll('.wp-block-whireland-team-member__btn');
    const teamMembers = document.querySelectorAll('.wp-block-whireland-team-member');

    function toggleBio(btn) {
        const teamMember = btn.closest('.wp-block-whireland-team-member');
        let state = teamMember.getAttribute('aria-expanded');

        if (state === 'true') {
            state = false;
        } else {
            state = true;
        }

        teamMembers.forEach((teamMember) => {
            teamMember.setAttribute('aria-expanded', 'false');
        });

        teamMember.setAttribute('aria-expanded', state);
    }

    teamMemberBtns.forEach((btn) => {
        btn.addEventListener('click', () => { toggleBio(btn); });
    });

    teamMembers.forEach((teamMember) => {
        teamMember.setAttribute('aria-expanded', 'false');
    });
});
